import auth from '../../../config/app-specific-config/auth';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import { SET_USER_ORG_ACTIVE_TEAM_MEMBERS } from './users-profile-actions-types';
import { GET_COWORKER_LIST_REQUEST,GET_COWORKER_LIST_SUCCESS, GET_COWORKER_LIST_FAILURE } from './get-active-coworker-list-action-types';


export const setUserOrgActiveTeamMembers = (orgActiveTeamMembers) => {
	return {
		type: SET_USER_ORG_ACTIVE_TEAM_MEMBERS,
		payload: orgActiveTeamMembers
	};
};

export const getCoworkerListRequest = () => {
	return {
		type: GET_COWORKER_LIST_REQUEST
	};
};

export const getCoworkerListSuccess = (response) => {
	return {
		type: GET_COWORKER_LIST_SUCCESS,
		payload: response.data
	};
};

export const getCoworkerListFailure = (error) => {
	return {
		type: GET_COWORKER_LIST_FAILURE,
		error
	};
};

export function getCoworkerList() {
	
	return async (dispatch) => {
		dispatch(getCoworkerListRequest());
		try {
			const url = `/organizations/get-active-team-members`;
			const headers = await auth.getAccessToken();

			const response = await axiosInstance.get(url, {headers});
			
			dispatch(setUserOrgActiveTeamMembers(response.data.data))
			dispatch(getCoworkerListSuccess(response.data.data));

		} catch (error) {
			dispatch(getCoworkerListFailure(error));
		}
	};
}


// export const userSelfSetupReset = () => {
// 	return {
// 		type: types.SELF_SETUP_NEW_ORG_USER_RESET
// 	};
// };

// export function resetUserSelfSetup() {

// 	return async (dispatch) => {
	
// 		try {
// 			dispatch(userSelfSetupReset());

// 		} catch (error) {
// 			dispatch(userSelfSetupFailure(error));
// 		}
// 	};
// }
